/**
 * Entry de la página `/briefings.html` — Fase 7g.1.
 *
 * Galería tabular de briefings que el usuario puede ver
 * (`visibility=public ∪ propios`; admin+ ve todos). Clic en una fila
 * navega a `/briefing.html?id=<id>` para abrirlo en el editor.
 */

import { mountBriefingsList } from './modules/briefings-list/mount.js';

mountBriefingsList();
